import useEdgeQuery from '@app/data/edge/hooks/useEdgeQuery';
import FETCH_SMS_PROFILE from '../queries/FetchSmsProfile';

const useSmsProfile = (options?: {}) => {
  const { data, loading, error } = useEdgeQuery(FETCH_SMS_PROFILE, options);

  return {
    data,
    loading,
    error,
  };
};

export default useSmsProfile;
